import React, { useState } from 'react'
import { RewardFriendModel } from 'models/recruit/RewardListModel'
import _orderBy from 'lodash/orderBy'
import { Translate } from 'utils/localize'
import Friend from './components/friend'
import { Icon } from '../../../../../../../../../../layouts'
import style from './Friends.module.scss'

const emptyRewards: Record<string, boolean> = {
    FirstPurchase: false,
    OmegaClonePurchased: false,
    PlexPurchased: false,
}

interface Props {
    friends: RewardFriendModel[]
}

const Friends = ({ friends }: Props): JSX.Element => {
    const [numberOfVisible, setNumberOfVisible] = useState(3)
    const renderFriends = (friendsList: RewardFriendModel[]): JSX.Element => {
        return (
            <>
                {friendsList.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Translate key={`key-friend-${index + 1}`}>
                        {({ translate }) => (
                            <>
                                <Friend
                                    title={`${translate(
                                        'recruit.recruitText'
                                    )} ${index + 1}`}
                                    date={item.dateAccepted}
                                    rewards={item.rewards}
                                />
                            </>
                        )}
                    </Translate>
                ))}
            </>
        )
    }

    return (
        <div className={style.friends}>
            {friends && friends.length > 0 ? (
                renderFriends(
                    _orderBy(friends, ['dateAccepted'], ['desc']).slice(
                        0,
                        numberOfVisible
                    )
                )
            ) : (
                <Translate>
                    {({ translate }) => (
                        <Friend
                            title={translate(
                                'recruit.startRecruiting'
                            ).toString()}
                            rewards={emptyRewards}
                        />
                    )}
                </Translate>
            )}
            {numberOfVisible < friends.length && (
                <div className={style.loadMore}>
                    <button
                        type="button"
                        onClick={() =>
                            setNumberOfVisible(numberOfVisible + 100)
                        }
                    >
                        <Translate id="recruit.showMore">Show more</Translate>
                        <Icon name="chevron-down" className={style.arrow} />
                    </button>
                </div>
            )}
        </div>
    )
}

export default Friends
